import { useSirenEntity } from '~/runtime';

export const FEEDING_PLAN_TEMPLATES_REL = 'https://api.binsentry.com/rel/individual-feed-plans';
export const FEED_REL = 'https://api.binsentry.com/rel/feeds';

export function useFeedingPlanTemplate({ templateHref }) {
  const { entity, loading } = useSirenEntity({ href: templateHref });
  return { feedingPlanTemplate: entity, loading };
}

export function useFeedingPlanTemplateName({ templateHref }) {
  const { entity, loading } = useSirenEntity({ href: templateHref });
  return { name: entity?.properties?.name, loading };
}

export function useFeedingPlanTemplates({ organizationHref }) {
  const { entity: organizationEntity, loading: organizationLoading } = useSirenEntity({ href: organizationHref });
  const feedingPlanTemplatesHref = organizationEntity?.getLink(FEEDING_PLAN_TEMPLATES_REL)?.href;
  const { entity: feedingPlanTemplatesEntity, loading: feedingPlanTemplatesLoading } = useSirenEntity({ href: feedingPlanTemplatesHref });

  return {
    feedingPlanTemplatesEntity,
    feedingPlanTemplates: feedingPlanTemplatesEntity?.getSubEntitiesByRel('item') || [],
    loading: organizationLoading || feedingPlanTemplatesLoading,
  };
}
